module.exports = __webpack_public_path__ + "img/contract.c04ca12b.svg";